// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e28e3ba","736":"2dca3667"}[chunkId] + ".chunk.js";
};